import { Injectable } from '@angular/core';

import { HttpClient } from '../_services/global-http.service';

@Injectable()
export class ResetPasswordService {
  constructor (private http: HttpClient) {}

  data: any;

  postResetPassword(email) {
    this.data = this.http.post('/api/reset_password/', { email: email });
    return this.data;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/reset-password.service.ts